import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Payment } from '../entities/payment';
import { catchError, Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment.development';
import { isPlatformBrowser } from '@angular/common';

interface ApiResponse {
  status: string;
  data: Payment | Payment[];
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private paymentServiceUrl = this.apiServicesUrl + '/payment';

  savePayment(payment: Payment): Observable<ApiResponse> {
    let token;
    if (isPlatformBrowser(this.platformId))
      token = sessionStorage.getItem('auth');
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + token
      })
    }
    return this.http.post<ApiResponse>(this.paymentServiceUrl, payment, httpHeaders)
    .pipe(
      catchError(this.handleError<ApiResponse>('postPayment'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(result as T);
    };
  }
}
